export const AGENT_AVATAR_CUTS = [
  "brilliant",
  "rhomboid",
  "torus",
  "pyramid",
  "ellipsoid",
  "step",
  "sphere",
  "wedge",
  "cabochon",
  "spire",
  "tablet",
  "bipyramid",
  "barrel",
  "star",
  "cone",
  "column",
] as const;
export const AGENT_AVATAR_COLOURS = [
  "azure",
  "blue",
  "violet",
  "orchid",
  "rose",
  "crimson",
  "tangerine",
  "amber",
  "olive",
  "moss",
  "green",
  "teal",
  "cyan",
  "white",
  "grey",
  "black",
] as const;
export type AgentAvatarCut = (typeof AGENT_AVATAR_CUTS)[number];
export type AgentAvatarColour = (typeof AGENT_AVATAR_COLOURS)[number];

export const isAgentAvatarCut = (value: unknown): value is AgentAvatarCut =>
  typeof value === "string" &&
  (AGENT_AVATAR_CUTS as readonly string[]).includes(value);
export const isAgentAvatarColour = (
  value: unknown,
): value is AgentAvatarColour =>
  typeof value === "string" &&
  (AGENT_AVATAR_COLOURS as readonly string[]).includes(value);
const AVATAR_HUES: Record<AgentAvatarColour, number> = {
  azure: 212,
  blue: 240,
  violet: 268,
  orchid: 296,
  rose: 324,
  crimson: 352,
  tangerine: 20,
  amber: 46,
  olive: 74,
  moss: 102,
  green: 130,
  teal: 158,
  cyan: 186,
  white: 0,
  grey: 210,
  black: 220,
};

/** Use only an API-assigned appearance; absent or invalid values stay unassigned. */
export function resolveAgentAvatarDisplay(avatar?: {
  status?: unknown;
  cut?: unknown;
  colour?: unknown;
  recoveryRequired?: boolean;
}) {
  if (avatar?.status === "unassigned") {
    return {
      cut: null,
      colour: null,
      recoveryRequired: true,
      status: "unassigned" as const,
    };
  }
  const storedCut = avatar?.cut;
  const storedColour = avatar?.colour;
  const valid =
    isAgentAvatarCut(storedCut) && isAgentAvatarColour(storedColour);
  return {
    cut: valid ? storedCut : null,
    colour: valid ? storedColour : null,
    recoveryRequired: valid ? Boolean(avatar?.recoveryRequired) : true,
    status: valid ? ("assigned" as const) : ("unassigned" as const),
  };
}

/** A readable, low-saturation message tint; it is never a persisted appearance value. */
export function getAgentAvatarMessageTint(colour: AgentAvatarColour): string {
  return `hsl(${AVATAR_HUES[colour]} 32% 94%)`;
}
